import React, { useState, useEffect } from "react";
import { TextField, Button, Typography, Container } from "@mui/material";
import Layout from "../../../layout/Layout";
import VenueMenu from "../../../components/VenueMenu";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  addReview,
  getReview,
  editReview,
} from "../../../services/venues/venueReviewsApi";
import ButtonBack from "../../../components/ButtonBack";

const AddEditReview = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  let location = useLocation();
  location = location.pathname.slice(1);

  const isEditMode = location === "add-new-reviews" ? false : true;

  const [reviewData, setReviewData] = useState({
    name: "",
    reviewsLink: "",
    stars: "",
  });

  useEffect(() => {
    if (id) {
      getReview(id)
        .then((data) => {
          setReviewData({
            name: data.name,
            reviewsLink: data.review_link,
            stars: data.stars,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [id]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setReviewData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const newReviewData = {
      name: reviewData.name,
      review_link: reviewData.reviewsLink,
      stars: reviewData.stars,
    };
    if (isEditMode) {
      editReview(id, newReviewData)
        .then((response) => {
          setReviewData({
            name: "",
            reviewsLink: "",
            stars: "",
          });

          navigate("/reviews");
        })
        .catch((error) => {
          console.error("Greška pri ažuriranju ", error);
        });
    } else {
      addReview(newReviewData)
        .then((response) => {
          setReviewData({
            ...reviewData,
            name: response.name,
            reviewsLink: response.review_link,
            stars: response.stars,
          });
          navigate("/reviews");
        })
        .catch((error) => {
          console.error("Greška pri dodavanju", error);
        });
    }
  };

  return (
    <Layout>
      <div>
        <VenueMenu />
        <div stile={{ width: "79%" }}>
          <ButtonBack />
          <div style={{ marginLeft: "26%" }}>
            <Typography variant="h4" gutterBottom sx={{ textAlign: "center" }}>
              Review
            </Typography>

            <form onSubmit={handleSubmit}>
              <Container>
                <div>
                  <TextField
                    sx={{ marginTop: "30px" }}
                    name="name"
                    label="Name"
                    required
                    value={reviewData.name}
                    fullWidth
                    onChange={handleInputChange}
                  />
                </div>

                <div>
                  <TextField
                    sx={{ marginTop: "30px" }}
                    name="reviewsLink"
                    label="Review Link"
                    value={reviewData.reviewsLink}
                    fullWidth
                    onChange={handleInputChange}
                  />
                </div>

                <div>
                  <TextField
                    sx={{ marginTop: "30px" }}
                    name="stars"
                    label="Stars"
                    value={reviewData.stars}
                    type="number"
                    fullWidth
                    inputProps={{ min: 1, max: 5 }}
                    onChange={handleInputChange}
                  />
                </div>
              </Container>

              <Container
                sx={{
                  marginTop: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  sx={{ m: 1, width: "25ch" }}
                  type="submit"
                  size="medium"
                  variant="outlined"
                >
                  {location === "add-new-reviews" ? "Publish" : "Save"}
                </Button>
              </Container>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AddEditReview;
